import styled from 'styled-components'

export const Container = styled.div`
  table {
    width: 100%;
    border-collapse: separate;
    border-spacing: 0 .75rem;
    font-size: .875rem;

    thead th {
      font-weight: 500;
      color: var(--c7);
      text-align: left;
      white-space: nowrap;

      padding: 0 1rem .5rem 1rem;
    }

    tbody {
      tr {
        background: var(--c1);
        box-shadow: 0px 0px 4px rgb(0, 0, 0, .1);
        transition: box-shadow .2s ease;

        :hover {
          box-shadow: 0px 0px 6px rgb(0, 0, 0, .2);
        }

        td {
          padding: .75rem 1rem;
          vertical-align: middle;
        }

        td:first-of-type {
          border-radius: .5rem 0 0 .5rem;
        }

        td:last-of-type {
          border-radius: 0 .5rem .5rem 0;
        }
      }
    }
  }
`

export const ColaboradorColumn = styled.td`
  cursor: pointer;

  strong {
    font-weight: 600;
    color: var(--Gray1);
  }

  span {
    font-size: .813rem;
    color: var(--c6);
  }
`

export const CargoColumn = styled.td`
  cursor: pointer;

  strong {
    font-weight: normal;
    color: var(--Gray1);
  }

  span {
    font-size: .813rem;
    color: var(--c6);
  }
`

export const PerfilColumn = styled.td`
  img:hover {
    transition: all .4s ease;
    cursor: pointer;
    filter: brightness(.825);
  }
`
